module.exports = __webpack_public_path__ + "static/image/history/pc/202501.ver2_0_2.png?e5c2dbf4";